import template from './procedure.html';
import controller from './procedure.controller';

let procedureComponent = {
    bindings: {
        model: '=',
        items: '=',
        itemTemplates: '=',
        editing: '<',
        displayFinals: '<',
        onDelete: '&',
        onItemSave: '&',
        associatingSpending: '<',
        onUpdateAssociatedAmount: '&'
    },
    template,
    controller
};

export default procedureComponent;
